<script lang="ts" setup>
import { ref, watch, useTemplateRef } from 'vue'
import { Menu } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import Sheet from '@/components/ui/sheet/Sheet.vue'
import SheetTrigger from '@/components/ui/sheet/SheetTrigger.vue'
import SheetContent from '@/components/ui/sheet/SheetContent.vue'
import SheetTitle from '@/components/ui/sheet/SheetTitle.vue'
import SheetDescription from '@/components/ui/sheet/SheetDescription.vue'
import NewsroomsText from '@/assets/images/Logo/LogoText.svg'
import { useTranslateKey } from '@/lib/utils'
import SidebarContent from './SidebarContent.vue'

const showSidebarMenu = ref(false)
const sidebarContentRef = useTemplateRef<InstanceType<typeof SidebarContent>>('sidebarContent')
const { translateKey } = useTranslateKey()

const handleClose = () => {
  showSidebarMenu.value = false
}

watch(showSidebarMenu, newValue => {
  if (!newValue) {
    sidebarContentRef.value?.resetNavbarState()
  }
})
</script>

<template>
  <div>
    <Sheet v-model:open="showSidebarMenu">
      <SheetTrigger as-child>
        <Button
          variant="ghost"
          data-testid="app-sidebar-trigger"
          class="flex items-center justify-center gap-3"
        >
          <Menu class="size-3.5 sm:size-4.5" />
          <img :src="NewsroomsText" alt="newsrooms" class="pointer-events-none h-2.5 sm:h-3" />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        class="flex max-w-full! border-0 p-0 transition-all duration-300"
        :class="sidebarContentRef?.showSubMenu ? 'w-[800px] max-[800px]:w-[400px]' : 'w-[400px]'"
      >
        <SheetDescription class="sr-only">{{
          translateKey('sidebarSheetDescription')
        }}</SheetDescription>
        <SheetTitle class="sr-only">{{ translateKey('sidebarSheetTitle') }}</SheetTitle>
        <SidebarContent ref="sidebarContent" :embedded="false" @close="handleClose" />
      </SheetContent>
    </Sheet>
  </div>
</template>
